module.exports = require('events').EventEmitter;



// WEBPACK FOOTER //
// /usr/local/www/sites/www.lactame.com/node/grm-data/git/cheminfo-js/molecular-formula/node_modules/readable-stream/lib/internal/streams/stream-browser.js